export const formatSettlementHeaderDate = (value) => {
  if (!value) {
    return "";
  }

  return new Date(value).toLocaleDateString("en-US", { timeZone: "UTC" });
};

export const toDateInputValue = (value) => {
  if (!value) {
    return "";
  }

  if (value instanceof Date) {
    if (Number.isNaN(value.getTime())) {
      return "";
    }

    const year = value.getFullYear();
    const month = `${value.getMonth() + 1}`.padStart(2, "0");
    const day = `${value.getDate()}`.padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  return String(value).slice(0, 10);
};

export const toDatePickerValue = (value) => {
  if (!value) {
    return null;
  }

  const normalizedValue = toDateInputValue(value);
  const date = new Date(`${normalizedValue}T00:00:00`);

  return Number.isNaN(date.getTime()) ? null : date;
};
